/**
 * Extract Spotify track ID from various Spotify URL formats
 * Examples:
 * - https://open.spotify.com/track/7tMF8Anyf7oIqQZSxE17do?si=b95a47a5e70a4de2
 * - https://open.spotify.com/album/0z7l9VEJyFMv8p8wffRDaF?highlight=spotify:track:2yuKbNMCQ8Oo6KWWZvUCoV
 */
export const getSpotifyTrackId = (url: string): string | null => {
  // Extract just the URL part (first whitespace-separated token) to handle trailing text
  const cleanUrl = url.trim().split(/\s+/)[0]

  // First try direct track URLs
  const trackMatch = cleanUrl.match(
    /(?:https?:\/\/)?(?:open\.)?spotify\.com\/track\/([a-zA-Z0-9]{22})(?:[/?#].*)?$/,
  )
  if (trackMatch && trackMatch[1]) {
    return trackMatch[1]
  }

  // Then try album URLs with highlight parameter
  const highlightMatch = cleanUrl.match(
    /highlight=spotify:track:([a-zA-Z0-9]{22})/,
  )
  if (highlightMatch && highlightMatch[1]) {
    return highlightMatch[1]
  }

  return null
}

/**
 * Check if a URL is a Spotify URL (track or album with highlighted track)
 */
export const isSpotifyUrl = (url: string): boolean => {
  // Extract just the URL part to handle trailing text
  const cleanUrl = url.trim().split(/\s+/)[0]

  // Check for direct track URLs or album URLs with highlighted tracks
  return (
    getSpotifyTrackId(url) !== null ||
    cleanUrl.includes('spotify.com/track/') ||
    (cleanUrl.includes('spotify.com/album/') &&
      cleanUrl.includes('highlight=spotify:track:'))
  )
}

/**
 * Generate Spotify embed URL from track ID
 */
export const getSpotifyEmbedUrl = (trackId: string): string => {
  return `https://open.spotify.com/embed/track/${trackId}?utm_source=generator`
}
